import { Controller } from "@hotwired/stimulus";

class MapController extends Controller {
  static targets = ["map"]
  static values = {
    lat: Number,
    lng: Number,
    name: String
  }

  connect() {
    this.initMap()
  }

  initMap() {
    console.log("initMap")

    this.map = new google.maps.Map(this.mapTarget, {
      center: {
        lat: this.latValue,
        lng: this.lngValue
      },
      zoom: 13,
    })
    this.buildMarker(this.latValue, this.lngValue, this.nameValue)
  }

  buildMarker(lat, lng, title) {
    const marker = new google.maps.Marker({
      position: {
        lat: lat,
        lng: lng,
      },
      title: title,
      map: this.map
    })
    const infoWindow = new google.maps.InfoWindow({content: title, maxWidth: 200});
    marker.addListener("click", () => {
      infoWindow.open(this.map, marker)
    })
    return marker
  }
}

export default MapController;